
import EventManager from "../../../manager/event_manager";
import TextureManager from "../../../manager/texture_manager";
import LanguageManager from "../../../manager/language_manager";
import Utility from "../../../utility/utility";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubRecordItem extends cc.Component {
    @property(cc.Label)
    timeLab:cc.Label = null

    @property(cc.Label)
    infoLab:cc.Label = null

    clubData = null

    setData( data: any, index){
        let str = ""
        switch(data.clubOpType){
            case "receive_advance":
                str = LanguageManager.t("club_record_receive_advance").format(data.opUserName, data.coins)
                break;
            case "persion_settle":
                str = LanguageManager.t("club_record_persion_settle").format(data.coins)
                break
            case "team_settle":
                str = LanguageManager.t("club_record_team_settle").format(data.coins)
                break  
            case "balance_incr":
                str = LanguageManager.t("club_record_balance_incr").format(data.opUserName, data.coins)
                break;
            case "balance_decr":
                str = LanguageManager.t("club_record_balance_decr").format(data.coins)
                break
            case "charge_real":
                let tagStr = ""
                if (data.accountType == 201){
                    tagStr = LanguageManager.t("club_record_bank")
                }
                else if (data.accountType == 200){
                    tagStr = LanguageManager.t("club_record_xiedai")
                }
                str = LanguageManager.t("club_record_charge_real").format(data.coins, tagStr)
                break 
            case "withdrawal_real":
                str = LanguageManager.t("club_record_withdrawal_real").format(data.coins)
                break;
            case "withdrawal_real_success":
                str = LanguageManager.t("club_record_withdrawal_real_success")
                break
            case "withdrawal_real_fail":
                str = LanguageManager.t("club_record_withdrawal_real_fail").format(data.coins)
                break 
            default:
                break;
        }
        this.timeLab.string = Utility.timeToStr(data.createTime)
        this.infoLab.string = str
    }
}
